'use strict';

import confModule from "../../config";
import serivceModule from "../services";

const serviceStorageModule = angular.module('tdl.services.storage', ['tdl.config', 'tdl.services', 'ngResource']);

export default serviceStorageModule;
